/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A model providing general information about the specified single client invite.
 */
export interface ClientInviteDetailModel { 
    id: number;
    inviteCode: string;
    email: string;
    userLanguage: string;
    createdAt: string;
    sentAt?: string | null;
    finishedAt?: string | null;
    inviteLink: string;
}

